import { http } from './config'

export default {
  verificacupom:(nm) => {
    return http.get('cupom.php?nm='+nm)
  },
  verificacupomusado:(cd_usuario,cd_cupom) => {
    return http.get('cupom_usuario.php?cd_usuario='+cd_usuario+'&cd_cupom='+cd_cupom)
  },
  registracupom:(cupom) => {
    return http.post('cupom.php',(cupom))
  },
  atualizaqtd:(qtd) => {
    return http.put('cupom.php',(qtd))
  }
}
